class Our_Team extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {
    // Browser calls this method when the element is added to the document
    const autoplaySpeed = this.getAttribute('autoplay-speed') || 6000;
    const prevArrow = this.querySelector(".swiper-button-prev-custom");
    const nextArrow = this.querySelector(".swiper-button-next-custom");

    this.swiper = new Swiper(this, {
      slidesPerView: 1.2,
      spaceBetween: 10,
      breakpoints: {
        640: {
          slidesPerView: 1.3,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 10,
        },
        990: {
          slidesPerView: 3.3,
          spaceBetween: 10,
        },
      },
  navigation: {
    nextEl: nextArrow,
    prevEl: prevArrow,
  },
      autoplay: {
        delay: Number(autoplaySpeed),
        disableOnInteraction: true,
      }
    });
  }

}

document.addEventListener('DOMContentLoaded', () => {
  customElements.define('our-team-component', Our_Team);
});

